export const screenSizeMediaQuery = {
    mobile: {
        query: '(max-width: 639px)'
    }
};
//# sourceMappingURL=constants.js.map